"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerImportResponseDto = exports.CustomerImportOptionsDto = exports.CustomerImportValidationDto = exports.AddFamilyDto = exports.AddImportedCustomerDto = void 0;
const customer_dto_1 = require("../../customers/dto/customer.dto");
const import_dto_1 = require("./import.dto");
class AddImportedCustomerDto extends customer_dto_1.CreateCustomerDto {
}
exports.AddImportedCustomerDto = AddImportedCustomerDto;
class AddFamilyDto {
}
exports.AddFamilyDto = AddFamilyDto;
class CustomerImportValidationDto extends import_dto_1.ImportValidationResponseDto {
}
exports.CustomerImportValidationDto = CustomerImportValidationDto;
class CustomerImportOptionsDto {
}
exports.CustomerImportOptionsDto = CustomerImportOptionsDto;
class CustomerImportResponseDto extends import_dto_1.ImportResponseDto {
}
exports.CustomerImportResponseDto = CustomerImportResponseDto;
//# sourceMappingURL=customer.dto.js.map